import React, { useRef } from 'react';
import './CtaButton.scss';
import contents from '../../contents';

function CtaButton({ handleMouseLeaveTooltip, handleMouseEnterTooltip }) {
  const ctaTooltip = useRef();
  return (
    <>
      <a href={contents.ctaTooltip.href} target="_blank" rel="sponspred noopener" className="cta">
        <button
          className="cta__button"
          onMouseEnter={(e) => {
            handleMouseEnterTooltip(e, ctaTooltip);
          }}
          onMouseLeave={() => {
            handleMouseLeaveTooltip(ctaTooltip);
          }}
        >
          FIND OUT MORE
          {/* <svg className="cta__arrow" viewBox="0 0 20 17" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19.7512 8.20765L18.68 7.08547L12.151 0.22998L9.79437 2.47434L13.7016 6.57539H0.521118V9.83991H13.7016L9.79437 13.941L12.151 16.1853L18.68 9.32982L19.7512 8.20765Z"
              fill="white"
            />
          </svg> */}
        </button>
      </a>
      <div className="tooltip" ref={ctaTooltip}>
        <p className="tooltip__content">{contents.ctaTooltip.copy}</p>
      </div>
    </>
  );
}

export default CtaButton;
